import { render } from "./WeeklyMeal.vue?vue&type=template&id=39662514"
import script from "./WeeklyMeal.vue?vue&type=script&lang=js"
export * from "./WeeklyMeal.vue?vue&type=script&lang=js"

import "./WeeklyMeal.vue?vue&type=style&index=0&id=39662514&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__